export const ResearchTypeOperationCrubs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Pratiche',
    path: '/pratiche',
  },
  {
    name: 'Ricerca Tipo Operazione',
    path: '/pratiche/ricerca-tipo-operazione',
  },
];

export const NewTypeOperationCrubs = [
  ...ResearchTypeOperationCrubs,
  {
    name: 'Nuovo Tipo Operazione',
    path: '/pratiche/ricerca-tipo-operazione/nuovo',
  },
];

export const EditTypeOperationCrubs = [
  ...ResearchTypeOperationCrubs,
  {
    name: 'Modifica Tipo Operazione',
    path: '/pratiche/ricerca-tipo-operazione/modifica',
  },
];

export const DetailTypeOperationCrubs = [
  ...ResearchTypeOperationCrubs,
  {
    name: 'Dettaglio Tipo Operazione',
    path: '/pratiche/ricerca-tipo-operazione/dettaglio',
  },
];
